import { State } from 'modules/data';

import { getPage } from '../pageSelectors';

export function getNetSuiteContext(state: State) {
    return getPage(state).netSuiteContext;
}
